import { FunctionComponent } from 'react'
import LayoutFlexItem from '@components/LayoutItem'
import { CookWidget } from '@widgets/types'
import useRenderer from '@hooks/useRenderer'
import { isNotNativeOnlyAd } from '@utils/ads'

export type ItemLayoutProps = Record<string, unknown> & {
  options?: Record<string, unknown>
  kind: string[]
  parentProps?: {
    parentGridPattern: '4|2|2' | '2|2|4'
  }
  content: (Record<string, any> & { kind: string[] })[]
}

const ItemLayout: FunctionComponent<ItemLayoutProps> = (props) => {
  const { options = {}, content } = props

  const nativeAdFreeContent = content.filter((innerWidget) =>
    isNotNativeOnlyAd(innerWidget)
  )

  const Renderer = useRenderer()

  if (nativeAdFreeContent.length === 0) {
    return null
  }

  const enhancedContent = nativeAdFreeContent.map((item) => ({
    ...item,
    parentProps: {
      ...options,
    },
  }))

  return (
    <LayoutFlexItem options={options}>
      <Renderer>{enhancedContent}</Renderer>
    </LayoutFlexItem>
  )
}

const widget: CookWidget = {
  kind: ['layout', 'item'],
  component: ItemLayout,
}

export default widget
